import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { history } from './history';
import config from '../config';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.appInsightsKey,
    enableCorsCorrelation: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { debug: false, history: history },
    },
  },
});
appInsights.loadAppInsights();

export function writeAIEvent(message: string) {
  appInsights.trackEvent({
    name: message,
  });
}
